"use client";
import React from "react";
import { ForgotPasswordHeader } from "./ForgotPasswordHeader";
import { ForgotPasswordForm } from "./ForgotPasswordForm";
import styles from "./ForgotPassword.module.css";

function ForgotPassword({ onBack }) {
  return (
    <div className={styles.forgotPasswordContainer}>
      {/* <ForgotPasswordHeader /> */}
      <ForgotPasswordForm onBack={onBack} />
    </div>
  );
}

export default ForgotPassword;
